var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { API_SVC_BASE_URL } from "../Config";
import { displayLocalTimestamp } from "./AllOrdersPage";
var ViewShipmentPhotosModal = /** @class */ (function (_super) {
    __extends(ViewShipmentPhotosModal, _super);
    function ViewShipmentPhotosModal(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            loading: false,
            success: false,
            errors: [],
            photos: []
        };
        return _this;
    }
    ViewShipmentPhotosModal.prototype.render = function () {
        var _this = this;
        return React.createElement(React.Fragment, null, this.props.photos.map(function (p, index) {
            return React.createElement("div", { key: index, className: 'photo' },
                "#",
                index + 1,
                " - ",
                displayLocalTimestamp(p.attachment.createdAt),
                React.createElement("img", { src: API_SVC_BASE_URL + ("/admin/orders/id/" + encodeURIComponent(_this.props.orderId) + "/shipments/id/" + encodeURIComponent(_this.props.shipmentId) + "/photos/id/" + p.id) }));
        }));
    };
    return ViewShipmentPhotosModal;
}(React.PureComponent));
export default ViewShipmentPhotosModal;
;
//# sourceMappingURL=ViewShipmentPhotos.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/ViewShipmentPhotos.js
// module id = 1200
// module chunks = 0